import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'bjorns_backyard';

const supportEmail = {
	[customerGroup]: 'bjorns_backyard@smoothr.de',
};
const firebaseConfig = {
	[customerGroup]: {
		apiKey: 'AIzaSyDEotTdHGF5Q_Vi5Nx8ogTSl-uaO6PwMjQ',
		authDomain: 'bjorns-backyard.firebaseapp.com',
		projectId: 'bjorns-backyard',
		storageBucket: 'bjorns-backyard.firebasestorage.app',
		messagingSenderId: '879121573408',
		appId: '1:879121573408:web:98d4f821f18c016eb1be45',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyAUJ0yCbuGUs9lDKehj-VGlD0oeU3XO__A',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup + '-dev',
	allergens_link: '',
	...apiEnvironment,
	hasRecommendations: true,
	hjid: 5035140,
	merchantId: '1110017883',
	merchantGoogleId: 'BCR2DN7TRCR2NIBO',
};
